<p>todo works!</p>
{{10+10}}
Hi, {{title}}
<br>
<br>
<br>
{{myarr[0]}}
<br><br>
{{name}}

<br>
<br>
<br>
<ul>
  <li *ngFor="let i of myarr">
    {{i}}
  </li>
</ul>

<p *ngIf="isValid">
  Hi I am in If Condition
</p>



<p>
  {{title | lowercase}}
</p>
<p>
  {{title | uppercase}}
</p>

<!-- Event Binding -->
<button class="btn btn-success" (click)='btn1Click()'>Click Here</button>
<br>
<br>
{{count}}

